/**
 * @packageDocumentation
 * @module f1/is
 */

import is_object from './is_object';

export interface IsIterable {
  /**
   * Can the object be iterated over (`for of`)
   *
   * @public
   * @function f1.is.iterable
   * @param u an object which may be iterable
   * @example
   *
   * ```ts
   * f1.is.iterable([]) => true
   * f1.is.iterable({}) => false
   * f1.is.iterable(new Map()) => true
   * ```
   */
  <V>(u: unknown): u is Iterable<V>;
}

/**
 * @see IsIterable
 */
export default <V>(u: unknown): u is Iterable<V> => {
  return is_object(u) && typeof u.next !== 'function' && Symbol.iterator in Object(u);
};
